// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import {parse_qs} from '@pub/util.js';

export const EMAIL_FIELD = 'username';
export const APP_NAME_FIELD = 'app.name';
export const APP_OS_FIELD = 'app.os';
export const MAX_EMAIL_LEN = 100;
export const MAX_PASS_LEN = 72;
export const UNKNOWN_ERROR = 'unknown';
export const AUTH_ERROR = {
    unauthorized: 'Invalid email and password pair',
    Unauthorized: 'Invalid email and password pair',
    'weak password': 'Password is too weak',
    'email-like password': 'Password mustn\'t contain a email address',
    google_login_only: 'Please use your Google account to log in',
    github_login_only: 'Please use your Github account to log in',
    wrong_password: 'Invalid email and password pair',
    invalid_2fa: 'Please enter a valid 2FA code sent to your email',
    [UNKNOWN_ERROR]: 'Failed to log in, please try again later',
};
export const ACTION = {
    SIGNIN: 'login',
    SIGNUP: 'signup',
    RESET: 'reset',
};

const {promo: promo_code, ref_code} = parse_qs();
export {promo_code, ref_code};
